// import { POST } from '@/services/Api'
import {
  InfoUserURL,
  CreateUserURL,
  DeleteUserURL,
  EditUserURL,
  ListUserURL,
  ValidateUserURL,
  LogoutUserURL,
  GetLoginPublicKeyURL,
  ChangePasswordURL,
  BatchResetUserPasswordURL
} from '@/consts/consts'
import {POST} from "@/utils/request/request";

export function InfoUser() {
  return POST(InfoUserURL)
}

export function CreateUser(data) {
  return POST(CreateUserURL, data)
}

export function DeleteUser(data) {
  return POST(DeleteUserURL, data)
}

export function EditUser(data) {
  return POST(EditUserURL, data)
}

export function ListUser(data) {
  return POST(ListUserURL, data)
}

export function ValidateUser(data) {
  return POST(ValidateUserURL, data)
}

export function LogoutUser() {
  return POST(LogoutUserURL)
}

export function GetLoginPublicKey() {
  return POST(GetLoginPublicKeyURL)
}

export function ChangePassword(data) {
  return POST(ChangePasswordURL, data)
}

export function BatchResetUserPassword(data) {
  return POST(BatchResetUserPasswordURL, data)
}
